<template>
  <UIDialog
    :is-open
    :z-index
    title="Add Arch Account"
    size="sm"
    @close="handleClose"
  >
    <div class="arch-account">
      <p>
        To connect your Arch Labs data with Allposit, please contact
        <a href="mailto:support@allposit.com">support@allposit.com</a>. An
        Arch Labs account is required.
      </p>
      <p v-if="isHubspotInited">
        You can also chat with our support team directly.
      </p>
    </div>
    <template v-if="isHubspotInited" #footer>
      <UIButton label="Chat with Support" @click="handleClickSupport" />
    </template>
  </UIDialog>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { ModalClass } from '@types'

import { useHubspot } from '@/plugins/hubspot'

import { UIDialog } from '@ui/modals'
import { UIButton } from '@ui/buttons'

type Props = {
  modal: ModalClass<any>
}

const props = defineProps<Props>()

const hubspot = useHubspot()

const isHubspotInited = computed(() => hubspot?.isLoaded)

const zIndex = computed(() => props.modal.zIndex)
const isOpen = computed(() => props.modal.isOpened)

const handleClose = () => {
  props.modal.close()
}

const handleClickSupport = () => {
  hubspot?.open()
}
</script>

<style>
.arch-account {
  p {
    @apply mb-2 last:mb-0;
  }
  a {
    @apply text-indigo-500 dark:text-indigo-400;
    @apply underline hover:no-underline;
  }
}
</style>
